import { apiGateway } from "@/_old/services/api-gateway";
import { productTypeIds } from "@/core/utils";

interface InsightsParams {
  startDate: string;
  endDate: string;
  companyId: number;
  cities?: string[] | null;
  spaces?: number[] | null;
  users?: number[] | null;
  status?: number[] | null;
  types?: string[] | null;
  group_id?: number | null;
}

interface CheckInRateResponse {
  percentage: number;
}

interface CancellationRateResponse {
  cancellation_rate: number;
}

const fetchCheckInRate = async (
  params: InsightsParams,
): Promise<CheckInRateResponse> => {
  const searchParams = new URLSearchParams();
  searchParams.set("start_date", params.startDate);
  searchParams.set("end_date", params.endDate);
  searchParams.set("company_id", params.companyId.toString());

  if (params.cities && params.cities.length > 0) {
    params.cities.forEach((city) => searchParams.append("cities[]", city));
  }
  if (params.spaces && params.spaces.length > 0) {
    params.spaces.forEach((space) =>
      searchParams.append("spaces[]", String(space)),
    );
  }
  if (params.users && params.users.length > 0) {
    params.users.forEach((user) =>
      searchParams.append("users[]", String(user)),
    );
  }
  if (params.status && params.status.length > 0) {
    params.status.forEach((s) => searchParams.append("status[]", String(s)));
  }
  if (params.types && params.types.length > 0) {
    params.types.forEach((type) =>
      searchParams.append("types[]", String(productTypeIds[type])),
    );
  }
  if (params.group_id) {
    searchParams.set("group_id", String(params.group_id));
  }

  const { data } = await apiGateway.get<CheckInRateResponse>(
    `/checkin-percentage?${searchParams.toString()}`,
  );

  return data;
};

const fetchCancellationRate = async (
  params: InsightsParams,
): Promise<CancellationRateResponse> => {
  const searchParams = new URLSearchParams();
  searchParams.set("start_date", params.startDate);
  searchParams.set("end_date", params.endDate);

  if (params.cities && params.cities.length > 0) {
    params.cities.forEach((city) => searchParams.append("cities[]", city));
  }
  if (params.spaces && params.spaces.length > 0) {
    params.spaces.forEach((space) =>
      searchParams.append("spaces[]", String(space)),
    );
  }
  if (params.users && params.users.length > 0) {
    params.users.forEach((user) =>
      searchParams.append("users[]", String(user)),
    );
  }
  if (params.status && params.status.length > 0) {
    params.status.forEach((s) => searchParams.append("status[]", String(s)));
  }
  if (params.types && params.types.length > 0) {
    params.types.forEach((type) =>
      searchParams.append("types[]", String(productTypeIds[type])),
    );
  }
  if (params.group_id) {
    searchParams.set("group_id", String(params.group_id));
  }

  const { data } = await apiGateway.get<CancellationRateResponse>(
    `/cancellation-rate?${searchParams.toString()}`,
  );

  return data;
};

export { fetchCheckInRate, fetchCancellationRate };
export type { InsightsParams, CheckInRateResponse, CancellationRateResponse };
